var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnterpriseCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/buildings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29044 15.7904C4.71079 16.3701 4.33333 17.3208 4.33333 18.8333V32.1667C4.33333 33.6792 4.71079 34.6299 5.29044 35.2096C5.87009 35.7892 6.82081 36.1667 8.33333 36.1667H16.8095C16.0095 35.1205 15.6667 33.7457 15.6667 32.1667V14.8333H8.33333C6.82081 14.8333 5.87009 15.2108 5.29044 15.7904ZM21.6667 36.1667C20.1541 36.1667 19.2034 35.7892 18.6238 35.2096C18.0441 34.6299 17.6667 33.6792 17.6667 32.1667V13.8333C17.6667 13.281 17.219 12.8333 16.6667 12.8333H8.33333C6.51252 12.8333 4.96324 13.2892 3.87623 14.3762C2.78921 15.4632 2.33333 17.0125 2.33333 18.8333V32.1667C2.33333 33.9875 2.78921 35.5368 3.87623 36.6238C4.96324 37.7108 6.51252 38.1667 8.33333 38.1667H21.6667C22.219 38.1667 22.6667 37.719 22.6667 37.1667C22.6667 36.6144 22.219 36.1667 21.6667 36.1667Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 8.16667C10.3856 8.16667 9.33333 9.21895 9.33333 10.5V12.8333H15.6667V8.83333C15.6667 8.60852 15.6727 8.38618 15.6871 8.16667H11.6667ZM7.33333 10.5C7.33333 8.11438 9.28105 6.16667 11.6667 6.16667H16.85C17.1607 6.16667 17.4537 6.31106 17.643 6.55743C17.8322 6.8038 17.8963 7.12414 17.8162 7.42433C17.7133 7.81043 17.6667 8.26612 17.6667 8.83333V13.8333C17.6667 14.3856 17.219 14.8333 16.6667 14.8333H8.33333C7.78105 14.8333 7.33333 14.3856 7.33333 13.8333V10.5Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 12.8333C23.8856 12.8333 24.3333 13.281 24.3333 13.8333V22.1667C24.3333 22.719 23.8856 23.1667 23.3333 23.1667C22.781 23.1667 22.3333 22.719 22.3333 22.1667V13.8333C22.3333 13.281 22.781 12.8333 23.3333 12.8333Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 12.8333C30.5523 12.8333 31 13.281 31 13.8333V22.1667C31 22.719 30.5523 23.1667 30 23.1667C29.4477 23.1667 29 22.719 29 22.1667V13.8333C29 13.281 29.4477 12.8333 30 12.8333Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3333 30.5C22.3333 29.031 23.531 27.8333 25 27.8333H28.3333C29.8023 27.8333 31 29.031 31 30.5V37.1667C31 37.719 30.5523 38.1667 30 38.1667H23.3333C22.781 38.1667 22.3333 37.719 22.3333 37.1667V30.5ZM25 29.8333C24.6356 29.8333 24.3333 30.1356 24.3333 30.5V36.1667H29V30.5C29 30.1356 28.6977 29.8333 28.3333 29.8333H25Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21.1667C10.5523 21.1667 11 21.6144 11 22.1667V28.8333C11 29.3856 10.5523 29.8333 10 29.8333C9.44772 29.8333 9 29.3856 9 28.8333V22.1667C9 21.6144 9.44772 21.1667 10 21.1667Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6238 5.79044C18.0441 6.37009 17.6667 7.32081 17.6667 8.83333V32.1667C17.6667 33.6792 18.0441 34.6299 18.6238 35.2096C19.2034 35.7892 20.1541 36.1667 21.6667 36.1667H31.6667C33.1792 36.1667 34.1299 35.7892 34.7096 35.2096C35.2892 34.6299 35.6667 33.6792 35.6667 32.1667V8.83333C35.6667 7.32081 35.2892 6.37009 34.7096 5.79044C34.1299 5.21079 33.1792 4.83333 31.6667 4.83333H21.6667C20.1541 4.83333 19.2034 5.21079 18.6238 5.79044ZM17.2096 4.37623C18.2966 3.28921 19.8459 2.83333 21.6667 2.83333H31.6667C33.4875 2.83333 35.0368 3.28921 36.1238 4.37623C37.2108 5.46324 37.6667 7.01252 37.6667 8.83333V32.1667C37.6667 33.9875 37.2108 35.5368 36.1238 36.6238C35.0368 37.7108 33.4875 38.1667 31.6667 38.1667H21.6667C19.8459 38.1667 18.2966 37.7108 17.2096 36.6238C16.1225 35.5368 15.6667 33.9875 15.6667 32.1667V8.83333C15.6667 7.01252 16.1225 5.46324 17.2096 4.37623Z",
    fill: "#A3A1AA"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseCity);
export default __webpack_public_path__ + "static/media/enterpriseCity.81c428e1.svg";
export { ForwardRef as ReactComponent };